<template>
  <div class="page page-recipe">

    <RecipeCmp :content="data" />

    <Footer />
    <GridHelper />
  </div>
</template>

<script>
import GridHelper from '@/components/GridHelper.vue'
import Footer from '@/components/Footer.vue'

import RecipeCmp from '@/components/Recipe.vue'

import i18n from '@/i18n/i18n'
import signals from '@/store/signals'

export default {
  name: 'Recipe',
  components: {
    RecipeCmp,
    Footer,
    GridHelper
  },
  beforeMount () {
     window.scrollTo(0, 0)
  },
  mounted () {
    signals.resetScrollama.dispatch()
  },
  data (props) {
    return {
      data: i18n.global.messages[i18n.global.locale].recipes[this.$route.params.slug],
    }
  },
  watch:{
    $route (to, from){
      this.data = i18n.global.messages[i18n.global.locale].recipes[this.$route.params.slug]
    }
  } 
}
</script>

<style lang="scss">
 
</style>
